<template>
  <HistoryRow>
    <template v-slot:icon>
      <span
        class="h-8 w-8 rounded-full bg-warning-500 flex items-center justify-center ring-8 ring-white text-white"
      >
        <IconNotification class="w-5 h-5 text-white"></IconNotification>
      </span>
    </template>

    <div>
      <p class="text-sm text-gray-500">
        <a href="#" class="font-medium text-gray-900" v-if="history.user">
          {{ history.user.name }}
        </a>
        {{ $t(`post.page.history.status.${history.action}`) }}
        {{ $t('post.page.history.from') }}
        <span class="text-gray-500">{{ getOldStatusName }}</span>
        {{ $t('post.page.history.to') }}
        <span class="text-gray-500">{{ getNewStatusName }}</span>
      </p>
      <!-- Motif de la décision : le serveur en trace le libellé, et l'a envoyé
           au citoyen en message privé. -->
      <blockquote v-if="reason" class="sh-reason">{{ reason }}</blockquote>
    </div>
    <div class="text-right text-sm whitespace-nowrap text-gray-500">
      {{ moment(history.created_at).format('D MMMM') }}
    </div>
  </HistoryRow>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import { mapState } from 'vuex'
import HistoryMixin from './HistoryMixin'

export default {
  name: 'StatusHistory',
  mixins: [HistoryMixin],

  computed: {
    ...mapState('post', {
      statuses: (state) => state.statuses,
    }),
    getNewStatusName() {
      return this.getStatusName(this.history.new_value.status)
    },
    getOldStatusName() {
      return this.getStatusName(this.history.old_value.status)
    },
    reason() {
      return (this.history.new_value && this.history.new_value.reason) || ''
    },
  },
  methods: {
    getStatusName(statusId) {
      if (statusId === null || statusId === undefined) {
        return this.$t('post.page.history.status.none')
      }
      if (!this.statuses) return String(statusId)
      const status = this.statuses.find((s) => s.id == statusId)
      if (!status) return String(statusId)
      const translation = status.translations
    ? status.translations.find((t) => t.locale === this.$i18n.locale)
    : null
    return translation ? translation.name : status.name || String(statusId)
    },
  },
}
</script>

<style scoped>
.sh-reason {
  margin: 6px 0 0;
  padding: 6px 10px;
  border-left: 3px solid #0891b2;
  background: #f8fafc;
  border-radius: 0 6px 6px 0;
  font-size: 0.82rem;
  line-height: 1.45;
  color: #334155;
  overflow-wrap: anywhere;
}
</style>
